import useGetApi from 'src/api/useGetApi';
import { RebateAgreementWithStructure } from './types';

const useRebateAgreement = (rebateAgreementId: string, enabled?: boolean) => {
  return useGetApi<RebateAgreementWithStructure>({
    endpoint: `rebates/agreements/${rebateAgreementId}`,
    options: {
      enabled: enabled && !!rebateAgreementId,
    },
  });
};

export default useRebateAgreement;
